<script>
import store from '@state/store'

export default {
  inheritAttrs: false,
  props: {},
  data() {
    return {
      repNum: '',
    }
  },
  computed: {},
  mounted() {
    this.showModal()
  },
  methods: {
    showModal() {
      // this.$refs['my-modal'].show()
      this.$bvModal.show('repNumModal')
    },
    handleSubmit() {
      store.commit('users/SET_REPNUM', this.repNum)
      localStorage.removeItem('embed_info')
      this.$router.go()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<template>
  <b-modal
    id="repNumModal"
    title="User Emulation"
    @ok="handleSubmit"
    @cancel="close"
    @close="close"
    @hide="close"
  >
    <form ref="form" @submit="handleSubmit">
      <b-form-group
        label="Enter rep number:"
        label-for="repNum-input"
        invalid-feedback="Name is required"
      >
        <b-form-input
          id="repNum-input"
          v-model="repNum"
          type="number"
          required
        ></b-form-input>
      </b-form-group>
    </form>
  </b-modal>
</template>
